import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/workspaces/$workspaceId/documents',
)({
  component: DocumentsLayout,
})

function DocumentsLayout() {
  return <Outlet />
}
